import React, { Component, useRef, useState, useEffect } from 'react';
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import { Link, useHistory } from 'react-router-dom';
import { ApiService } from '../../containers/Services/apiservice';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { Helmet } from 'react-helmet';
import Chart from "react-apexcharts";
import { Watch } from "react-loader-spinner";
import SweetAlert from 'react-bootstrap-sweetalert';
let apiServices = new ApiService();
const Dashboard = () => {
  let history = useHistory();
  const [riskprofilestatus, Setriskprofilestatus] = useState('');
  const [riskscore, Setriskprofilescore] = useState('');
  const [riskprofile, Setriskprofile] = useState('');
  const [userid, SetUserid] = useState();
  const [showgraph, Setshowgraph] = useState(false);
  const didMountRef = useRef(true);
  const [graphData, setgraphData] = useState([]);
  const [canstatusmsg, setCanStatus] = useState('You Have Not Registered For eCAN Please Register It To Invest In Mutual Fund By Clicking Here');
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [Clickhere, setClickhere] = useState(0);
  const [CanId, setCanId] = useState('');
  const [EpayezzReg, setEpayezzReg] = useState(0);
  const [BankManApprove, setBankManApprove] = useState(0);
  const [UserBankData, SetUserBankData] = useState({});
  const [ePayEezzStatus, SetePayEezzStatus] = useState('');
  const [EpayezzStatusMessage, SetEpayezzStatusMessage] = useState('Please Check ePayEezz Registration Status');
  const [linkurl, setlinkurl] = useState('#');
  const [AlertColor, setAlertColor] = useState('alert alert-info tx-14 d-flex align-items-center');
  const [registerStatus, setRegisterStatus] = useState('')
  const [investorConcent, setInvestorConcent] = useState('')
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (didMountRef.current) {
      // SetePayEezzStatus('');

      setSpinnerLoading(true);
      // setTimeout(() => {
      //   setSpinnerLoading(false);
      // }, 4000);
      const dataString2 = {
      }
      apiServices.getcheckconcentstatusPostRequest(dataString2).then(result => {
        console.log(result)
      })
      const dataString = {
      }
      apiServices.getUserData(dataString).then(result => {
        console.log(res)
        if (result.data.status == 'success') {
          // 
          var res = result.data.data;
          if (res.gs_can_register == 1) {
            setCanStatus('Your CAN is approved - Start Investing');
            setClickhere(1);
          }
          else if (result.data.status == "error" && result.data.message == "Session expired") {
            localStorage.removeItem('AUTH_TOKEN');
            // alert(result.data.message)
            setSpinnerLoading(false)
            history.push("/login")
          }
          else {
            canstatus(res.gs_can_register);
          }
          setCanId(res.gs_can_id);
          setRegisterStatus(res.gs_can_register)
          setBankManApprove(res.gs_epayezz_bankapprove);
          setEpayezzReg(res.gs_epayezz_reg);
          setInvestorConcent(res.gs_investor_concent_status)
          setSpinnerLoading(false);
          if (res.gs_risk_assestment_status == 1) {
            Setriskprofilestatus(res.gs_risk_assestment_status);
            Setriskprofilescore(res.gs_risk_assestment_score);
            setSpinnerLoading(false);
            const dataStringscore = {
              "score": res.gs_risk_assestment_score,
            }
            apiServices.getriskprofile(dataStringscore).then(result => {
              if (result.data.status == 'success') {
                Setriskprofile(result.data.data)
                setSpinnerLoading(false);
              }
              else if (result.data.status == "error" && result.data.message == "Session expired") {
                localStorage.removeItem('AUTH_TOKEN');
                // alert(result.data.message)
                setSpinnerLoading(false)
                history.push("/login")
              }
              else {
                alert(res.data.message)
                setSpinnerLoading(false)
              }
            })
            showusergraphdata();
          }
        }
      })
      getusrbanks();
    }
    didMountRef.current = false;
  }, []);
  const canstatus = (canregstatus) => {
    setSpinnerLoading(true);
    var canstatus = 0
    if (canregstatus == 5) {
      setCanStatus('You have not done your KYC Kindly get your KYC done and then complete your eCAN Register here To Invest In Mutual Fund');
      setClickhere(5);
    } else {
      const canststatusdatastring = {
      }
      apiServices.canvalidation(canststatusdatastring).then(result => {
        if (result.data.respStatus && result.data.respStatus === '0') {
          if (result.data.responseList.canStatus === 'AP') {
            setCanStatus('Your CAN is approved - Start Investing');
            setClickhere(1);
            canstatus = 1;
          } else if (result.data.responseList.canStatus == "PE") {
            setCanStatus('your CAN is still under process. It will take a couple of hours, you can visit us again.');
            setClickhere(2);
            canstatus = 2;
          } else if (result.data.responseList.canStatus == "RJ") {
            setCanStatus('Your eCAN Has Been Rejected');
            setClickhere(3);
            canstatus = 4;
          } else if (result.data.responseList.canStatus == "OH") {
            setCanStatus('Your CAN is on hold. Please check the mail you have received from MFUTILITY and resolve the discrepancy.');
            setClickhere(4);
            canstatus = 3;
          }
          else {
            setCanStatus('You Have Not Registered For eCAN Please Register It To Invest In Mutual Fund By Clicking Here');
            setClickhere(0);
          }
          const dataString = {
            "can_status": canstatus
          }
          apiServices.savecanstatus(dataString).then(result => {
            console.log(result)
            setSpinnerLoading(false)
          })
        }
        else if (result.data.status == "error" && result.data.message == "Session expired") {
          localStorage.removeItem('AUTH_TOKEN');
          // alert(result.data.message)
          setSpinnerLoading(false)
          history.push("/login")
        }
        else {
          alert(result.data.message)
          setSpinnerLoading(false)
        }
      })
    }
  };
  const checkriskprofile = (e) => {
    if (riskprofilestatus == 1) {
      history.push("/goalsettings");
    }
    else {
      history.push("/risk-assestment");
    }
  };
  const gotonewgoal = (e) => {
    history.push("/goalsettings");
  };
  const gotomfsip = (e) => {
    if (BankManApprove == 1) {
      history.push("/mutualfunds/sip");
    }
    else {
      history.push("/mferror");
    }
  };
  const gotomfpurchase = () => {
    if (Clickhere == 1) {
      history.push("/mutualfunds/purchase");
    } else {
      alert('Your CAN Is Not Approved Till Now');
      return false;
    }
  }
  const gotoriskprofile = () => {
    history.push("/risk-assestment");
  }
  const Healthcareplan = (e) => {
    history.push("/healthcareplan");
  };
  const getusrbanks = () => {
    setSpinnerLoading(true);
    const dataString = {
    }
    apiServices.getusercanbankdata(dataString).then(res => {
      if (res.data.status == 'success') {
        SetUserBankData(res.data.data)
        setSpinnerLoading(false);
      }
      else if (res.data.status == "error" && res.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        // alert(res.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        alert(res.data.message)
        setSpinnerLoading(false)
      }
    }
    )
  }
  const checkmandatestatus = (bankno) => {
    setSpinnerLoading(true);
    const dataString = {
      "bankno": bankno
    }
    apiServices.epayeezzstatus(dataString).then(res => {
      if (res.data.respStatus == '0') {
        if (res.data.epayStatusResponse[0].mmrnAggrStatus == 'RQ') {
          SetePayEezzStatus('Pending');
          setAlertColor('alert alert-warning tx-14 d-flex align-items-center');
          SetEpayezzStatusMessage('Your ePayEezz registration Request Is Requested By Aggregator')
        } else if (res.data.epayStatusResponse[0].mmrnAggrStatus == 'PS') {
          SetePayEezzStatus('Pending');
          setAlertColor('alert alert-warning tx-14 d-flex align-items-center');
          SetEpayezzStatusMessage('Request Acknowledged By Aggregator')
        }
        else if (res.data.epayStatusResponse[0].mmrnAggrStatus == 'AC' || res.data.epayStatusResponse[0].mmrnAggrStatus == 'RA') {
          SetePayEezzStatus('Please Try Again')
          setAlertColor('alert alert-danger tx-14 d-flex align-items-center')
          setlinkurl('/epayezzregistration')
          SetEpayezzStatusMessage('Your Aggregator Is Rejected')
        } else if (res.data.epayStatusResponse[0].mmrnAggrStatus == 'PA') {
          SetePayEezzStatus('View')
          setAlertColor('alert alert-success tx-14 d-flex align-items-center')
          SetEpayezzStatusMessage('Your ePayEezz registration Is Confirmed')
          setlinkurl('/profile')
        } else if (res.data.epayStatusResponse[0].mmrnAggrStatus == 'PR' || res.data.epayStatusResponse[0].mmrnAggrStatus == 'PF') {
          SetePayEezzStatus('Rejected (Start Again)')
          setAlertColor('alert alert-danger tx-14 d-flex align-items-center')
          SetEpayezzStatusMessage('Your ePayEezz registration Is Rejected By Aggregator')
          setlinkurl('/epayezzregistration')
        }
        else if (res.data.epayStatusResponse[0].mmrnAggrStatus == 'SE') {
          SetePayEezzStatus('Pending');
          setAlertColor('alert alert-warning tx-14 d-flex align-items-center');
          SetEpayezzStatusMessage('Your ePayEezz registration Request Is Send to Aggregator')
        }
        else if (res.data.epayStatusResponse[0].mmrnAggrStatus == 'PE') {
          SetePayEezzStatus('Pending');
          setAlertColor('alert alert-warning tx-14 d-flex align-items-center');
          SetEpayezzStatusMessage('Your ePayEezz registration Request Is Underprocess')
        }
        else if (res.data.epayStatusResponse[0].mmrnAggrStatus == 'AC') {
          SetePayEezzStatus('Cancelled (Start Again)')
          setAlertColor('alert alert-danger tx-14 d-flex align-items-center')
          SetEpayezzStatusMessage('Your ePayEezz registration Request Is Cancelled By Aggregator')
          setlinkurl('/epayezzregistration')
        }
        else if (res.data.epayStatusResponse[0].mmrnAggrStatus == 'AK') {
          setlinkurl('/profile')
          SetePayEezzStatus('View')
          setAlertColor('alert alert-success tx-14 d-flex align-items-center')
          SetEpayezzStatusMessage('Your ePayEezz registration Request Is Accepted By Aggregator')
        }
        setSpinnerLoading(false)
      }
      else if (res.data.status == "error" && res.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        alert(res.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        alert(res.data.message)
        setSpinnerLoading(false)
      }
    }
    )
  }
  const showusergraphdata = (e) => {
    setSpinnerLoading(true);
    const usergraphdatastring = {
    }
    apiServices.getusergraphdata(usergraphdatastring).then(result => {
      if (result.data.status == 'success') {
        var graphdata = result.data.graphdata;
        if (graphdata.length > 0) {
          Setshowgraph(true)
        }
        setgraphData(graphdata);
        setSpinnerLoading(false);
      }
      else if (result.data.status == "error" && result.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        // alert(result.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        alert(result.data.message)
        setSpinnerLoading(false)
      }
    })
  };
  const canregisterstatus = () => {
    setShow(true)
  }
  const closealert = () => {
    setShow(false)
  }
  return (
    <div>
      <Header />
      <Helmet>
        <title>Dashboard - Goalstox</title>
        {/* <meta name="keywords" content={pageKeywords}/>  */}
        {/* <meta name="description" content={pageDescription} /> */}
      </Helmet>
      <section className='bg-gray-light section-small'>
        <div className={spinnerLoading == true ? 'parentDisable' : ''} width="100%">
          <div className='overlay-box'>
            <Watch
              color="#ffffff"
              visible={spinnerLoading}
            />
          </div>
        </div>
        <div className="container-fluid">
          <div className='row'>
            {/* <div className='col-lg-2'>
            <div className="row mg-t-20">

            <div className='panel cust-details'>
              {registerStatus == 1
            ? <div className='profie-avtar' style={{marginBottom:"10px"}}>
            <div className='profile-avtar-mediadone'><i className="fa fa-check" aria-hidden="true"></i></div>
            <div className='profile-avtar-dontent'>
      <Link><h6 className = 'mg-b-0' style={{color:"green"}}>Can Status</h6> </Link>
      </div>
          </div>
               :
               <div className='profie-avtar' style={{marginBottom:"10px"}}>
                  <div className='profile-avtar-medianotdone'><i className="fa fa-times" aria-hidden="true"></i></div>
                  <div className='profile-avtar-dontent'>
            <Link to="/canregister"><h6 className = 'mg-b-0' style={{color:"red"}}>Can Status<i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></h6> </Link>
            </div>
            </div>
                }
                   {registerStatus == 1
            ? <div className='profie-avtar' style={{marginBottom:"10px"}}>
            <div className='profile-avtar-mediadone'><i className="fa fa-check" aria-hidden="true"></i></div>
            <div className='profile-avtar-dontent'>
      <Link><h6 className = 'mg-b-0' style={{color:"green"}}>Bank Mandate</h6> </Link>
      </div>
          </div>
               :
               <div className='profie-avtar' style={{marginBottom:"10px"}}>
                  <div className='profile-avtar-medianotdone' ><i className="fa fa-times" aria-hidden="true"></i></div>
                  <div className='profile-avtar-dontent'>
            <Link to="/canregister"><h6 className = 'mg-b-0' style={{color:"red"}}>Bank Mandate<i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></h6> </Link>
            </div>
            </div>
                }
             {investorConcent == 1
            ?
            <div className='profie-avtar' style={{marginBottom:"10px"}}>
                  <div className='profile-avtar-mediadone'><i className="fa fa-check" aria-hidden="true"></i></div>
                  <div className='profile-avtar-dontent'>
                           <Link to="/holdings" ><h6 className = 'mg-b-0' style={{color:"green"}}>One glance portfolio<i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true" style={{marginLeft: "4px"}}></i></h6> </Link>
                  </div>
                </div>
               :<div className='profie-avtar' style={{marginBottom:"10px"}}>
               <div className='profile-avtar-medianotdone'><i className="fa fa-times" aria-hidden="true"></i></div>
               <div className='profile-avtar-dontent'>
                        <Link to="/investorconcent"><h6 className = 'mg-b-0' style={{color:"red"}}>One glance portfolio<i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true" style={{marginLeft: "4px"}}></i></h6> </Link>
               </div>
             </div> }
                {EpayezzReg == 1
            ? <div className='profie-avtar' style={{marginBottom:"10px"}}>
            <div className='profile-avtar-mediadone'><i className="fa fa-check" aria-hidden="true"></i></div>
            <div className='profile-avtar-dontent'>
                     <Link ><h6 className = 'mg-b-0' style={{color:"green"}}>Epayezee </h6> </Link>
            </div>
          </div>
               :<div className='profie-avtar' style={{marginBottom:"10px"}} >
               <div className='profile-avtar-medianotdone'><i className="fa fa-times" aria-hidden="true"></i></div>
               <div className='profile-avtar-dontent'>
                        <Link to="/epayezzregistration"><h6 className = 'mg-b-0' style={{color:"red"}}>Epayezee <i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></h6> </Link>
               </div>
             </div>}
             <div className='profie-avtar'  style={{marginBottom:"10px"}}>
               <div className='profile-avtar-mediadone' style={{backgroundColor:"#d7e0fd"}}><i class="fa fa-university" aria-hidden="true" style={{color : "#3C3C3C"}}></i></div>
               <div className='profile-avtar-dontent'>
                        <Link to="/addmorebank"><h6 className = 'mg-b-0' style={{color : "#3C3C3C"}} >Add more Banks <i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true" ></i></h6> </Link>
               </div>
             </div>
             <div className='profie-avtar' style={{marginBottom:"10px"}}>
               <div className='profile-avtar-mediadone' style={{backgroundColor:"#d7e0fd"}}><i class="fa fa-user" aria-hidden="true" style={{color : "#3C3C3C"}}></i></div>
               <div className='profile-avtar-dontent'>
                        <a href='https://mfuonline.com/CNOMV' target="new"><h6 className = 'mg-b-0' style={{color : "#3C3C3C"}} >Nominee Verify<i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true" ></i></h6> </a>
               </div>
             </div>
              </div>
                       </div>
            </div> */}
            <div className='col-lg-12'>
              <div className="row">
                {(() => {
                  if (Clickhere == 1) {
                    if (EpayezzReg == 0) {
                      return (
                        <>
                          <div className='col-12'>
                            <div className="alert alert-primary tx-14 d-flex align-items-center" role="alert">
                              Please complete ePayEezz registration
                              <Link to="/epayezzregistration" class="buttonab-line-3 ml-auto">Start Now <i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></Link>
                            </div>
                          </div>
                          <div className='col-12'>
                            <div className='goalsetting-block mg-b-15'>
                              <h6>Your eCAN Has Been Approved Start Investing Now </h6>
                              <h6 className='mg-b-0'>Your CAN Id Is {CanId}</h6>
                            </div>
                          </div>
                        </>
                      );
                    }
                    else {
                      if (UserBankData.crn_bank1_approve_status == 0)
                        return (
                          <>
                            <div className='col-12'>
                              <div className={AlertColor} role="alert">
                                {EpayezzStatusMessage}{' For ' + UserBankData.crb_bank1}
                                <button onClick={(e) => { checkmandatestatus(1) }} className="buttonab-line-3 ml-auto">
                                  {ePayEezzStatus != '' && ePayEezzStatus != null && ePayEezzStatus != undefined ? <Link to={linkurl} className="buttonab-line-3 mg-r-20 ml-auto">{ePayEezzStatus}<i class="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></Link>
                                    : <>Click Here<i class="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></>}</button>
                              </div>
                            </div>
                            <div className='col-12'>
                              <div className='goalsetting-block mg-b-15'>
                                <h6 className='mg-b-0'>Your eCAN Has Been Approved Start Investing Now </h6>
                                <h6 className='mg-b-0'>Your CAN Id Is {CanId}</h6>
                              </div>
                            </div>
                          </>
                        );
                      if (UserBankData.crn_bank2_approve_status == 0) {
                        return (
                          <>
                            <div className='col-12'>
                              <div className={AlertColor} role="alert">
                                {EpayezzStatusMessage}{' For ' + UserBankData.crb_bank2}
                                <button onClick={(e) => { checkmandatestatus(2) }} className="buttonab-line-3 ml-auto">{ePayEezzStatus != '' && ePayEezzStatus != null && ePayEezzStatus != undefined ? ePayEezzStatus : <>Check Now<i class="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></>}</button>
                              </div>
                            </div>
                            <div className='col-12'>
                              <div className='goalsetting-block mg-b-15'>
                                <h6 className='mg-b-0'>Your eCAN Has Been Approved Start Investing Now </h6>
                                <h6 className='mg-b-0'>Your CAN Id Is {CanId}</h6>
                              </div>
                            </div>
                          </>);
                      }
                      if (UserBankData.crn_bank3_approve_status == 0) {
                        return (
                          <>
                            <div className='col-12'>
                              <div className={AlertColor} role="alert">
                                {EpayezzStatusMessage}{' For ' + UserBankData.crb_bank3}
                                <button onClick={(e) => { checkmandatestatus(3) }} class="buttonab-line-3 ml-auto">{ePayEezzStatus != '' && ePayEezzStatus != null && ePayEezzStatus != undefined ? ePayEezzStatus : <>Check Now<i class="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></>}</button>
                              </div>
                            </div><div className='col-12'>
                              <div className='goalsetting-block mg-b-15'>
                                <h6 className='mg-b-0'>Your eCAN Has Been Approved Start Investing Now </h6>
                                <h6 className='mg-b-0'>Your CAN Id Is {CanId}</h6>
                              </div>
                            </div>
                          </>);
                      }
                    }
                  }
                  if (Clickhere == 0) {
                    return (
                      <div className='col-12'>
                        <div className='goalsetting-block mg-b-15'>
                          <h6 className='mg-b-0'><Link to="/canregister">{canstatusmsg}<i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></Link></h6>
                        </div>
                      </div>
                    );
                  } else if (Clickhere == 5) {
                    return (
                      <div className='col-12'>
                        <div className='goalsetting-block mg-b-15'>
                          <h6 className='mg-b-0'><Link to="/canregister/5">{canstatusmsg}<i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></Link></h6>
                        </div>
                      </div>
                    );
                  }
                  else if (Clickhere == 3) {
                    return (
                      <div className='col-12'>
                        <div className='goalsetting-block mg-b-15'>
                          <h6 className='mg-b-0'><Link to="/canregister">{canstatusmsg}<i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></Link></h6>
                        </div>
                      </div>
                    );
                  }
                  else if (Clickhere == 1) {
                    return (
                      <div className='col-12'>
                        <div className='goalsetting-block mg-b-15'>
                          <h6>{canstatusmsg}</h6>
                          <h6 className='mg-b-0'>CAN Id Is {CanId}</h6>
                        </div>
                      </div>
                    );
                  } else {
                    return (
                      <div className='col-12'>
                        <div className='goalsetting-block mg-b-15'>
                          <h6>{canstatusmsg} </h6>

                          <h6 className='mg-b-0'>Your Provisional CAN Id Is {CanId}</h6>
                        </div>
                      </div>
                    );
                  }
                })()}
                {/* {canstatusmsg} */}

                {/* </div> */}

                {/* </div> */}
              </div>
              <div className='row g-3 mg-b-15'>
                <div className='col-lg-2 col-6'>
                  {(() => {
                    if (registerStatus == 1) {
                      return (
                        <div className='icbox'>
                          <div className='icbox-img'>
                            <div className='icbox-status success'><i class="fa fa-check" aria-hidden="true"></i></div>
                            <img src="/img/customer.png"></img>
                          </div>
                          <span>CAN Registration</span>
                        </div>)
                    }
                    else if (registerStatus == 2 || registerStatus == 3) {
                      return (
                        <div className='icbox' onClick={canregisterstatus}>
                          <div className='icbox-img'>
                            <div className='icbox-status panding'><i className="fa fa-times" aria-hidden="true"></i></div>
                            <img src="/img/customer.png"></img>
                          </div>
                          <span>CAN Registration</span>
                        </div>
                      )
                    }
                    else {
                      return (
                        <Link to="/canregister">
                          <div className='icbox'>
                            <div className='icbox-img'>
                              <div className='icbox-status panding'><i class="fa fa-times" aria-hidden="true"></i></div>
                              <img src="/img/customer.png"></img>
                            </div>
                            <span>CAN Registration</span>
                          </div>
                        </Link>
                      )
                    }
                  })()}
                </div>

                <div className='col-lg-2 col-6'>
                  {(() => {
                    if (registerStatus == 1) {
                      return (
                        <div className='icbox'>
                          <div className='icbox-img'>
                            <div className='icbox-status success'><i className="fa fa-check" aria-hidden="true"></i></div>
                            <img src="/img/bank.png"></img>
                          </div>
                          <span>Bank Mandate</span>
                        </div>)
                    }
                    else if (registerStatus == 2 || registerStatus == 3) {
                      return (
                        <div className='icbox' onClick={canregisterstatus}>
                          <div className='icbox-img'>
                            <div className='icbox-status panding'><i className="fa fa-times" aria-hidden="true"></i></div>
                            <img src="/img/bank.png"></img>
                          </div>
                          <span>Bank Mandate</span>
                        </div>
                      )
                    }
                    else {
                      return (
                        <Link to="/canregister">
                          <div className='icbox' >
                            <div className='icbox-img'>
                              <div className='icbox-status panding'><i className="fa fa-times" aria-hidden="true"></i></div>
                              <img src="/img/bank.png"></img>
                            </div>
                            <span>Bank Mandate</span>
                          </div>
                        </Link>)
                    }
                  })()}
                </div>
                <div className='col-lg-2 col-6'>
                  {(() => {
                    if (investorConcent == 1) {
                      return (<Link to="/holdings">
                        <div className='icbox'>
                          <div className='icbox-img'>
                            <div className='icbox-status success'><i class="fa fa-check" aria-hidden="true"></i></div>
                            <img src="/img/briefcase.png"></img>
                          </div>
                          <span>One Glance Portfolio</span>
                        </div></Link>)
                    }
                    else if (investorConcent == 2 || investorConcent == 3) {
                      return (
                        <div className='icbox' onClick={canregisterstatus}>
                          <div className='icbox-img'>
                            <div className='icbox-status panding'><i className="fa fa-times" aria-hidden="true"></i></div>
                            <img src="/img/briefcase.png"></img>
                          </div>
                          <span>One Glance Portfolio</span>
                        </div>
                      )
                    }
                    else {
                      return (
                        <Link to="/investorconcent">
                          <div className='icbox'>
                            <div className='icbox-img'>
                              <div className='icbox-status panding'><i className="fa fa-times" aria-hidden="true"></i></div>
                              <img src="/img/briefcase.png"></img>
                            </div>
                            <span>One Glance Portfolio</span>
                          </div>
                        </Link>)
                    }
                  })()}
                </div>
                <div className='col-lg-2 col-6'>

                  {(() => {
                    if (EpayezzReg == 1) {
                      return (
                        <Link>
                          <div className='icbox'>
                            <div className='icbox-img'>
                              <div className='icbox-status success'><i class="fa fa-check" aria-hidden="true"></i></div>
                              <img src="/img/credit-card.png"></img>
                            </div>
                            <span>Epayezee</span>
                          </div></Link>)
                    }
                    else if (investorConcent == 2 || investorConcent == 3) {
                      return (
                        <div className='icbox' onClick={canregisterstatus}>
                          <div className='icbox-img'>
                            <div className='icbox-status panding'><i className="fa fa-times" aria-hidden="true"></i></div>
                            <img src="/img/credit-card.png"></img>
                          </div>
                          <span>Epayezee</span>
                        </div>
                      )
                    }
                    else {
                      return (
                        <Link to="/epayezzregistration">
                          <div className='icbox'>
                            <div className='icbox-img'>
                              <div className='icbox-status panding'><i className="fa fa-times" aria-hidden="true"></i></div>
                              <img src="/img/credit-card.png"></img>
                            </div>
                            <span>Epayezee</span>
                          </div>
                        </Link>
                      )
                    }
                  })()}
                </div>
                <div className='col-lg-2 col-6'>
                  <Link to="/epayezzregistration">
                    <div className='icbox'>
                      <div className='icbox-img'>
                        <div className='icbox-status'></div>
                        <img src="/img/add.png"></img>
                      </div>
                      <span>Add Epayezee</span>
                    </div>
                  </Link>
                </div>
                <div className='col-lg-2 col-6'>
                  <a href="https://mfuonline.com/CNOMV" target="new">
                    <div className='icbox'>
                      <div className='icbox-img'>
                        <div className='icbox-status'></div>
                        <img src="/img/add-user.png"></img>
                      </div>
                      <span> Verify Nominee</span>
                    </div>
                  </a>
                </div>
              </div>
              <div className='row'>
                {/* <div className='col-lg-4'>
                           <div className='panel cust-details'>
                           <Link to="/canregister"><h6>Investor Concent<i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></h6> </Link>
                           <Link to="/canregister"><h6>Epayezee<i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></h6> </Link>
                           <Link to="/canregister"><h6>One glance portfolio<i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></h6> </Link>
                       </div>
                       </div> */}
                <div className='col-lg-12'>
                  <div className='panel p25'>
                    <div className='row'>
                      <div className='col-lg-4 border-right' onClick={gotomfsip}>
                        <div className='icobox'>
                          <div className='icobox-media'><i className="fa fa-line-chart" aria-hidden="true"></i></div>
                          <div className='icobox-content'>
                            <h6 className='mg-b-0'>Start an SIP<i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></h6>
                            {/* <span className='tx-12 fw500'>GOALSTOX0001</span> */}
                          </div>
                        </div>
                      </div>
                      <div className='col-lg-4 border-right' onClick={gotomfpurchase}>
                        <div className='icobox'>
                          <div className='icobox-media'><i className="fa fa-money" aria-hidden="true"></i></div>
                          <div className='icobox-content'>
                            <h6 className='mg-b-0'>Do Lumpsum Investment<i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></h6>
                            {/* <span className='tx-12 fw500'>GOALSTOX0001</span> */}
                          </div>
                        </div>
                      </div>
                      <div className='col-lg-4 border-right' onClick={gotonewgoal}>
                        <div className='icobox icobox-last'>
                          <div className='icobox-media'><i className="fa fa-trophy" aria-hidden="true"></i></div>
                          <div className='icobox-content'>
                            <h6 className='mg-b-0'>Create New Goal<i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></h6>
                            {/* <span className='tx-12 fw500'>GOALSTOX0001</span> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className='row'>
            <div className='col-lg-12'>
              <div className='panel cust-details'>
                <div className='row'>
                  <div className='col-lg-4 border-right'>
                  <div className='profie-avtar'>
                  <div className='profile-avtar-media'>K</div>
                  <div className='profile-avtar-dontent'>
                  <h6 className='mg-b-0'>Hi Admin grove4</h6>
                  <span className='tx-12 fw500'>GOALSTOX0001</span>
                  </div>
                </div>
                  </div>
                  <div className='col-lg-2 border-right'>
                    <div className='probox tx-center'>
                      <span className='tx-12 fw500'>CURRENT VALUE</span>
                      <h6 className='mg-b-0'>₹30,000.00</h6>
                    </div>
                  </div>
                  <div className='col-lg-2 border-right'>
                    <div className='probox tx-center'>
                      <span className='tx-12 fw500'>INVESTMENT</span>
                      <h6 className='mg-b-0'>₹50,000.00</h6>
                    </div>
                  </div>
                  <div className='col-lg-2 border-right'>
                    <div className='probox tx-center'>
                      <span className='tx-12 fw500'>RETURNS</span>
                      <h6 className='mg-b-0 tx-green'>₹9000.00</h6>
                    </div>
                  </div>
                  <div className='col-lg-2'>
                    <div className='probox tx-center'>
                      <span className='tx-12 fw500'>AVG RETURNS (%)</span>
                      <h6 className='mg-b-0 tx-green'>23.3%</h6>
                    </div>
                  </div>
                </div>
               
              </div>
              
            </div>
          </div> */}
              {
                riskprofile != '' ?
                  <div className="row mg-t-20">
                    <div className="col-lg-8 col-12">
                      {showgraph == true ?

                        graphData.map(key => {
                          const guestSeries = [
                            {
                              name: 'Invested',
                              type: 'column',
                              data: key.invested
                            }, {
                              name: 'Planned',
                              type: 'area',
                              data: key.planned
                            }, {
                              name: 'Actual',
                              type: 'line',
                              data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39]
                            }
                          ];
                          const guestOption = {
                            chart: {
                              toolbar: {
                                show: false
                              },
                              height: 200,
                              type: 'line',
                              stacked: false,
                            },
                            stroke: {
                              width: [0, 3, 3],
                              curve: 'smooth'
                            },
                            plotOptions: {
                              bar: {
                                columnWidth: '30%'
                              }
                            },
                           fill: {
                              opacity: [0.85, 0.25, 1],
                              gradient: {
                                inverseColors: false,
                                shade: 'light',
                                type: "vertical",
                                opacityFrom: 0.85,
                                opacityTo: 0.55,
                                stops: [0, 100, 100, 100]
                              }
                            },
                            labels: key.years,
                            markers: {
                              size: [0, 3, 0]
                            },
                            xaxis: {
                              tickAmount: 6,
                            },
                            yaxis: {
                              title: {
                                text: '',
                              },
                              tickAmount: 7,
                              min: 0,
                            },
                            tooltip: {
                              shared: true,
                              intersect: false,
                              y: {
                                formatter: function (y) {
                                  if (typeof y !== "undefined") {
                                    return y.toFixed(0) + " Rs";
                                  }
                                  return y;
                                }
                              }
                            }
                          };
                          return (
                            <div className='goalsetting-block mg-b-15'>
                              <div className='row'>
                                <div className='col-lg-5 border-right'>
                                  <h4 className='tx-18'>{key.goaldetails.name}</h4>
                                  <h6 className='tx-13 mg-b-5'>{key.goaldetails.type}</h6>
                                  <div className='goalsetting-list'>
                                    <ul>
                                      <li>Amount :<span>₹{key.goaldetails.amount}</span></li>
                                      <li>Current Investment : <span><Link to={`/goal-detail/${key.goaldetails.gs_id}`}>₹{key.goaldetails.current}</Link></span></li>
                                      <li>Maturity Year :<span>{key.goaldetails.maturity}</span></li>
                                      <li>Goal Start Date :<span>{key.goaldetails.datetime}</span></li>
                                      <li>Folio No :<span>-</span></li>
                                    </ul>
                                  </div>
                                  {registerStatus == 1
                                    ? <>{
                                      BankManApprove == 1 ?
                                        <Link to={`/sipinvestment/${key.goaldetails.gs_id}`} onClick={localStorage.removeItem("SELMFS")} class="mg-t-20 buttonab-line-3">Start Investment <i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></Link>
                                        :
                                        <Link to="/mferror" className="mg-t-20 buttonab-line-3">Start Investment <i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></Link>
                                    }</> : ""}
                                </div>
                                <div className='col-lg-7'>
                                  <Chart type="line" series={guestSeries} options={guestOption} width='100%' />
                                </div>
                              </div>
                            </div>
                          )
                        }) : ''
                      }
                      <div className='panel'>
                        {showgraph == false ?
                          <div className="golstarbox text-center">
                            <div>
                              <img src="img/holdings.svg" className="wd-100"></img>
                              <p>Add goals & start investing if you can plan yourself and only want to help us in tracking. </p>
                              <button type="submit" onClick={checkriskprofile} className="mt-10 buttonab-line">Start investing <i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></button>
                            </div>
                          </div> : ''
                        }
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className='risk-result tx-center mg-b-15'>
                        <h5 className='mg-b-10'>Your Risk Profile</h5>
                        <span> {riskprofile}({riskscore}) </span>
                        <div style={{ width: 150, height: 150, margin: "20px auto" }}>
                          <CircularProgressbar value={riskscore} text={`${riskscore}`} />
                        </div>
                        <button type="submit" onClick={gotoriskprofile} className="buttonab-line mg-t-20">Edit Risk Profile <i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></button>
                      </div>
                      {showgraph == true ?
                        <div className='panel'>
                          <div className='risk-result tx-center mg-b-15'>
                            <div className="golstarbox-second text-center">
                              <div>
                                <img src="img/holdings.svg" className="wd-100"></img>
                                <p>Add goals & start investing if you can plan yourself and only want to help us in tracking. </p>
                                <button type="submit" onClick={checkriskprofile} className="mt-10 buttonab-line">Add New Goal <i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></button>
                              </div>
                            </div>
                          </div>
                        </div> : ''
                      }
                      <div className='panel'>
                        {/* {BankManApprove == 1?    */}
                        {/* <div className="golstarbox-second text-center">
            <div>
                  <Link to="/mutualfunds/purchase"  className="mt-10 buttonab-line">Purchase<i class="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></Link>
                  <Link to = "/mutualfunds/sip" className="mt-10 buttonab-line">SIP<i class="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></Link>
                  <Link to = "/switchinvestment" className="mt-10 buttonab-line">Switch<i class="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></Link>
                  <Link to = "/swpinvestment" className="mt-10 buttonab-line">SWP<i class="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></Link>
                  <Link to="/stpinvestment"className="mt-10 buttonab-line">STP<i class="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></Link>
                  <Link to ="/redeeminvestment" className="mt-10 buttonab-line">Redeem<i class="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></Link>
                </div>
                </div> */}
                        {/* :''
          } */}
                      </div>
                    </div>
                  </div> :
                  <div className="row mg-t-20">
                    <div className="col-lg-12 col-12">
                      <div className='panel'>
                        {showgraph == false ?
                          <div className="golstarbox text-center">
                            <div>
                              <img src="img/holdings.svg" className="wd-100"></img>
                              <p>Add goals & start investing if you can plan yourself and only want to help us in tracking. </p>
                              <button type="submit" onClick={checkriskprofile} className="mt-10 buttonab-line">Start investing <i class="fa fa-long-arrow-right mg-l-10" aria-hidden="true"></i></button>
                            </div>
                          </div> : ''
                        }
                      </div>
                    </div>
                  </div>
              }
              {
    /* <div className="row">
            <div className="col-lg-6">
      </div> */}
              {/* <div className="col-lg-6">
              <div className="golstarbox text-center"> <img src="img/holdings.svg" className="wd-100" />
                <p>Setup an online meeting with investment advisor and start investing </p>
                <button type="submit" onClick={Healthcareplan} className="btn btn-primary mt-10 button04">Healthcare</button>
              </div>
            </div> */}{/* 
            <div className="col-lg-4">
              <div className="golstarbox text-center"> <img src="img/holdings.svg" className="wd-100" />
                <p>Get some inspiration on how planning can help you manage goals better</p>
                <button type="button" className="btn btn-primary mt-10 button04">Continue</button>
              </div>
            </div> */}
              {/* </div> */}
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <SweetAlert danger confirmBtnCssClass='alertpop' confirmBtnText='OK' show={show} onConfirm={closealert}>
        <p>{canstatusmsg}</p>
      </SweetAlert>
    </div>
  );
}
export default Dashboard;